import { RecordsTablePanel } from "#src/batteries-included-components";
import { ApplyAutomationProgressBanner } from "#src/batteries-included-components/Banners/ApplyAutomationProgressBanner";
import { RecordsViewFilterArea } from "#src/batteries-included-components/FilterAreas/RecordsFilterAreas";
import { DefaultRecordValueConfigTablePanel } from "#src/batteries-included-components/Panels/TablePanels/DefaultRecordValueConfigTablePanel";
import { EquipmentUpdateStatusBanner } from "#src/components/Organization/Facilities/Detail/Equipment/EquipmentUpdateStatusBanner";
import { useStorageKey } from "#src/hooks/useStorageKey";
import { ButtonToggleGroup } from "@validereinc/common-components";
import { AssetType } from "@validereinc/domain";
import React, { useState } from "react";

export const EquipmentRecordsTab = ({
  equipmentId,
}: {
  equipmentId: string;
}) => {
  const [filterConfigStorageKey, viewConfigStorageKey] = useStorageKey(
    ["filter-configuration", "view-configuration"],
    ["records", "list", "equipment"]
  );
  const [tableConfigStorageKey, tableStateStorageKey] = useStorageKey(
    ["table-configuration", "table-state"],
    ["records", "list", "equipment", equipmentId]
  );
  const [applySeededAutomationJobStorageKey] = useStorageKey(
    ["async-job"],
    "equipment-seeded-automation-job-configuration"
  );
  const [drvcTableConfigStorageKey, drvcTableStateStorageKey] = useStorageKey(
    ["table-configuration", "table-state"],
    ["records", "default-record-value-configuration", "list", "equipment"]
  );

  const [mode, setMode] = useState<"records" | "automation">("records");

  return (
    <>
      <EquipmentUpdateStatusBanner />
      <div
        style={{
          marginRight: 8,
          display: "flex",
          gap: 8,
          marginBottom: 16,
          alignItems: "center",
        }}
      >
        <ButtonToggleGroup
          name="records-switcher"
          activeKey={mode}
          items={[
            { label: "Records", dataKey: "records" },
            { label: "Default Automations", dataKey: "automation" },
          ]}
          onChange={(val) => setMode(val as "records" | "automation")}
        />
        <RecordsViewFilterArea
          viewConfigStorageKey={viewConfigStorageKey}
          isPeriodDateRange={true}
          isPeriodAvailable={mode === "records"}
        />
      </div>
      {mode === "records" && (
        <>
          <ApplyAutomationProgressBanner
            jobStorageKey={applySeededAutomationJobStorageKey}
            showCounts={false}
          />
          <RecordsTablePanel
            type={AssetType.EQUIPMENT}
            filterConfigStorageKey={filterConfigStorageKey}
            tableConfigStorageKey={tableConfigStorageKey}
            viewConfigStorageKey={viewConfigStorageKey}
            applySeededAutomationJobStorageKey={
              applySeededAutomationJobStorageKey
            }
            tableStateStorageKey={tableStateStorageKey}
          />
        </>
      )}
      {mode === "automation" && (
        <DefaultRecordValueConfigTablePanel
          type={AssetType.EQUIPMENT}
          tableConfigStorageKey={drvcTableConfigStorageKey}
          viewConfigStorageKey={viewConfigStorageKey}
          tableStateStorageKey={drvcTableStateStorageKey}
        />
      )}
    </>
  );
};
